import React, { useRef, useState } from "react";
import Modal from "@mui/material/Modal";
import { Box, IconButton, Typography } from "@mui/material";
import CustomButton from "../../../components/Button";
import generatePDF from "react-to-pdf";
import CloseIcon from "@mui/icons-material/Close";
import { useAppDispatch } from "../../../store/hooks";
import { downloadExcel } from "../../../slices/billingInvoices.slice";
import { Loader } from "../../../components/Loader/Loader";
const modalStyle = {
  position: "absolute",
  top: "2%",
  left: "30%",
  height: "100%",
  width: 950,
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 15,
  overflow: "scroll",
};
export interface ModalProps {
  isOpen: any;
  onClose: any;
  title: string;
  htmlString: string;
  invoiceId: string;
}

const ViewBillModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  htmlString,
  invoiceId,
}) => {
  const invoiceRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const [downloadingExcel, setDownloadingExcel] = useState(false);

  const downloadPDF = async () => {
    const pdf = await generatePDF(invoiceRef, {
      filename: "page.pdf",
      method: "build",
      page: {
        margin: 5,
        format: [251, 355],
      },
    });
    pdf.save("Invoice");
  };

  const downloadExcelFile = async () => {
    setDownloadingExcel(true);
    await dispatch(downloadExcel(invoiceId));
    setDownloadingExcel(false);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Box display="flex" justifyContent="center" m={2}>
          <Typography variant="h6" color="primary">
            {title}
          </Typography>
        </Box>
        <IconButton
          onClick={() => onClose(true)}
          sx={{ float: "right", marginTop: -7 }}
        >
          <CloseIcon></CloseIcon>
        </IconButton>
        <Box display="flex" justifyContent="flex-end" mr={2} gap={2}>
          <CustomButton onClick={downloadPDF}>Download PDF</CustomButton>
          <CustomButton onClick={downloadExcelFile} disabled={downloadingExcel}>
            Download Excel {downloadingExcel && <Loader type="button" />}
          </CustomButton>
        </Box>
        <div style={{ height: "90%", overflowX: "auto" }}>
          <div
            ref={invoiceRef}
            dangerouslySetInnerHTML={{ __html: htmlString }}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default ViewBillModal;
